const api_url = "https://clairity-api-22fkap56fq-uc.a.run.app/clairity";

export default api_url;